import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Paper, Typography, Breadcrumbs, Link } from "@mui/material";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";
import BulkImportWizard from "../../components/users/BulkImportWizard";

/**
 * Page for bulk importing users via CSV
 */
const BulkImportPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
      >
        <Link
          component="button"
          variant="body1"
          onClick={() => navigate("/users")}
          sx={{
            textDecoration: "none",
            color: "text.primary",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Users
        </Link>
        <Typography color="text.primary">Import CSV</Typography>
      </Breadcrumbs>

      {/* Page Title */}
      <Typography variant="h4" component="h1" gutterBottom>
        Bulk Import Users
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Import multiple users at once by uploading a CSV file. The system will
        validate each row and show you which users can be imported successfully.
      </Typography>

      {/* Import Wizard */}
      <Paper elevation={2} sx={{ p: 4, mt: 3 }}>
        <BulkImportWizard />
      </Paper>
    </Container>
  );
};

export default BulkImportPage;
